import { XMarkIcon } from '@heroicons/react/16/solid';
import { GoInfo } from 'react-icons/go';
import { PrevalenceBreakdownContent, hasPrevalenceBreakdownData } from './PrevalenceBreakdownContent';

type PrevalenceBreakdownPanelProps = {
  rowData: any;
  onClose: () => void;
};

export function PrevalenceBreakdownPanel({ rowData, onClose }: PrevalenceBreakdownPanelProps) {
  const diseaseLabel = rowData?.diseaseName || rowData?.name || rowData?.diseaseUMLSCUI || '';
  const hasData = hasPrevalenceBreakdownData(rowData);

  return (
    <div className="flex flex-col h-full bg-white overflow-hidden">
      <div className="flex items-center justify-between flex-shrink-0 px-4 py-3 border-b border-gray-200 bg-gray-50">
        <div className="flex items-center gap-1.5 min-w-0">
          <GoInfo className="w-5 h-4 stroke-1 text-blue m-1" />
          <h2 className="text-sm font-semibold text-gray-900 truncate min-w-0 mb-0 pb-0">
            Prevalence Breakdown
          </h2>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-200 flex-shrink-0"
          aria-label="Close prevalence breakdown"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>

      {diseaseLabel && (
        <div className="px-4 py-2 bg-blue-50 border-b border-blue-100">
          <p className="text-xs font-medium text-blue-800 truncate mb-0" title={diseaseLabel}>
            {diseaseLabel}
          </p>
        </div>
      )}

      <div className="flex-1 overflow-y-auto p-3 min-h-0">
        {hasData ? (
          <PrevalenceBreakdownContent rowData={rowData} />
        ) : (
          <p className="text-sm text-gray-400 text-center mt-6">No prevalence data available.</p>
        )}
      </div>
    </div>
  );
}
